/**
 * Generer CSV fra række-data og trigger download.
 * Bruger semikolon-separator (dansk Excel-standard) + UTF-8 BOM så danske
 * tegn (æ, ø, å) vises korrekt i Excel.
 */
export function downloadCsv(rows, filename) {
    const csv = rows
        .map((r) =>
            r
                .map((cell) => {
                    const s = cell === null || cell === undefined ? "" : String(cell);
                    return /[",;\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
                })
                .join(";")
        )
        .join("\n");
    const blob = new Blob(["\uFEFF" + csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
}

export const today = () => new Date().toISOString().slice(0, 10);
